/* esm.sh - @internetarchive/donation-form-edit-donation@1.1.6 */
import{__decorate as r}from"/tslib?target=es2022";import{LitElement as E,html as a,css as s,nothing as y}from"/lit@^2.8.0?target=es2022";import{customElement as N,property as m,query as C,state as k}from"/lit@^2.8.0/decorators?target=es2022";import b from"/currency.js@^2.0.4?target=es2022";import{DonationType as h,DonationPaymentInfo as S,defaultDonationAmounts as q,defaultSelectedDonationInfo as L}from"/@internetarchive/donation-form-data-models@^0.3.6?target=es2022";import{CurrencyValidator as _}from"/@internetarchive/donation-form-currency-validator@^0.3.1?target=es2022";import{DonationFormSectionBadgeMode as A}from"/@internetarchive/donation-form-section@^0.3.6?target=es2022";var p;(function(i){i.HideNumbers="hidenumbers",i.ShowNumbers="shownumbers"})(p||(p={}));var d;(function(i){i.DonationType="donationType",i.Amount="amount"})(d||(d={}));var c;(function(i){i.ValidDonationAmount="valid_donation_amount",i.InvalidDonationAmount="invalid_donation_amount",i.DonationTooHigh="donation_too_high",i.DonationTooLow="donation_too_low"})(c||(c={}));var l;(function(i){i.Button="button",i.Checkbox="checkbox",i.Hide="hide"})(l||(l={}));var v;(function(i){i.SingleLine="single-line",i.MultiLine="multi-line"})(v||(v={}));var u=class extends E{constructor(){super(...arguments),this.donationInfo=L,this.stepNumberMode=p.ShowNumbers,this.amountOptions=q,this.amountSelectionLayout=v.MultiLine,this.frequencySelectionMode=l.Button,this.customAmountMode="display",this.coverFeesCheckboxMode="display",this.amountTitleDisplayMode="default",this.customAmountSelected=!1,this.currencyValidator=new _}render(){let o=this.amountTitleDisplayMode==="default"?"Choose an amount (USD)":"";return a`
      ${this.frequencySelectionMode===l.Button?this.frequencyButtonsTemplate:y}

      <donation-form-section
        sectionBadge="${this.amountSelectionSectionNumber}"
        headline=${o}
        badgeMode=${this.formSectionNumberMode}
      >
        ${this.amountTitleDisplayMode==="slot"?a`<slot name="edit-donation-amount-title"></slot>`:y}
        <ul class="amount-selector">
          ${this.presetAmountsTemplate}
          ${this.customAmountMode==="display"?a`<li class="custom-amount">${this.customAmountTemplate}</li>`:y}
        </ul>

        <div class="errors">${this.error}</div>

        ${this.coverFeesCheckboxMode==="display"?a` <div class="checkbox-options">
              ${this.coverFeesCheckboxTemplate}
              ${this.frequencySelectionMode===l.Checkbox?this.frequencyCheckboxTemplate:y}
            </div>`:y}
      </donation-form-section>
    `}updated(t){t.has("customAmountSelected")&&this.customAmountButton&&(this.customAmountButton.checked=this.customAmountSelected),t.has("amountOptions")&&(this.customAmountSelected=!1,this.updateSelectedDonationInfo(),this.setupAmountColumnsLayoutConfig()),t.has("amountSelectionLayout")&&this.setupAmountColumnsLayoutConfig(),t.has("donationInfo")&&this.updateSelectedDonationInfo(),t.has("defaultSelectedAmount")&&this.defaultSelectedAmount!==void 0&&(this.customAmountSelected=!1,this.donationInfo=new S({donationType:this.donationInfo.donationType,amount:this.defaultSelectedAmount,coverFees:this.donationInfo.coverFees}))}get frequencyButtonsTemplate(){return a`
      <donation-form-section
        sectionBadge="1"
        headline="Choose a frequency"
        badgeMode=${this.formSectionNumberMode}
      >
        <ul class="frequency-selector">
          ${this.frequencyTemplate}
        </ul>
      </donation-form-section>
    `}get frequencyCheckboxTemplate(){return a`
      <div class="checkbox-option-container">
        <input
          type="checkbox"
          id="make-this-monthly"
          @input=${this.monthlyCheckboxChecked}
          .checked=${this.donationInfo.donationType===h.Monthly}
          tabindex="0"
        />
        <label for="make-this-monthly"> Make this monthly </label>
      </div>
    `}get coverFeesCheckboxTemplate(){return a`
      <div class="checkbox-option-container">
        <input
          type="checkbox"
          id="cover-fees"
          @input=${this.coverFeesChecked}
          .checked=${this.donationInfo.coverFees}
          tabindex="0"
        />
        <label for="cover-fees"> ${this.coverFeesTextTemplate} </label>
      </div>
    `}get amountSelectionSectionNumber(){return this.frequencySelectionMode===l.Button?2:1}get formSectionNumberMode(){switch(this.stepNumberMode){case p.ShowNumbers:return A.ShowBadge;case p.HideNumbers:return A.HideBadge}}setupAmountColumnsLayoutConfig(){let t=this.customAmountMode==="hide"&&this.coverFeesCheckboxMode==="hide"&&this.frequencySelectionMode===l.Hide,o=this.amountOptions.length,e=5,n=3;switch(o){case 7:e=5,n=3;break;case 6:e=4,n=2;break;case 5:e=4,n=3;break;case 4:if(t){e=4,n=0;break}e=3,n=2;break;case 3:e=2,n=1;break}this.amountSelectionLayout===v.SingleLine&&(e=o+3,n=3),this.style.setProperty("--paymentSelectorAmountColumnCount",`${e}`),this.style.setProperty("--paymentSelectorCustomAmountColSpan",`${n}`)}updateSelectedDonationInfo(){var t,o;let e=((t=this.shadowRoot)===null||t===void 0?void 0:t.activeElement)===this.customAmountInput;if(!this.isCustomAmount&&!(this.customAmountSelected&&e)){let n=(o=this.shadowRoot)===null||o===void 0?void 0:o.querySelector(`input[type="radio"][name="${d.Amount}"][value="${this.donationInfo.amount}"]`);n.checked=!0,this.customAmountSelected=!1,this.error=void 0,this.customAmountInput&&(this.customAmountInput.value="")}else if(this.customAmountSelected=!0,!e){this.customAmountInput.value=this.customAmountDisplayValue;let n=this.getDonationInfoStatus(this.donationInfo.amount);this.handleDonationInfoStatus(n)}}get coverFeesTextTemplate(){let t=b(this.donationInfo.fee,{symbol:"$"}).format();return a` I'll generously add ${t} to cover fees. `}formatShortenedAmount(t){let o=t%1===0?0:2;return b(t,{symbol:"$",precision:o}).format()}get frequencyTemplate(){return a`
      <li>
        ${this.getRadioButton({group:d.DonationType,value:h.OneTime,displayText:"One time",checked:this.donationInfo.donationType===h.OneTime})}
      </li>

      <li>
        ${this.getRadioButton({group:d.DonationType,value:h.Monthly,displayText:"Monthly",checked:this.donationInfo.donationType===h.Monthly})}
      </li>
    `}get presetAmountsTemplate(){return a`
      ${this.amountOptions.map(t=>{let o=!this.customAmountSelected&&t===this.donationInfo.amount,e=this.formatShortenedAmount(t);return a`
          <li>
            ${this.getRadioButton({group:d.Amount,value:`${t}`,displayText:`${e}`,checked:o})}
          </li>
        `})}
    `}getRadioButton(t){let o=`${t.group}-${t.value}-option`;return a`
      <div class="selection-button">
        <input
          type="radio"
          name=${t.group}
          value=${t.value}
          id=${o}
          tabindex="0"
          .checked=${t.checked}
          @change=${this.radioSelected}
          @click=${e=>{t.group===d.Amount&&parseFloat(t.value)===this.donationInfo.amount&&this.radioSelected(e)}}
        />
        <label for=${o}> ${t.displayText} </label>
      </div>
    `}get isCustomAmount(){return!this.amountOptions.includes(this.donationInfo.amount)}get customAmountDisplayValue(){return this.isCustomAmount?b(this.donationInfo.amount,{symbol:""}).format():""}get customAmountTemplate(){return a`
      <div class="selection-button">
        <input
          type="radio"
          name=${d.Amount}
          value="custom"
          id="custom-amount-button"
          tabindex="0"
          @change=${this.customRadioSelected}
        />

        <label for="custom-amount-button">
          <span class="custom-amount-text">Custom: $</span
          ><input
            type="text"
            id="custom-amount-input"
            tabindex="-1"
            value=${this.customAmountDisplayValue}
            @input=${this.customAmountChanged}
            @keydown=${this.currencyValidator.keydown}
            @focus=${this.customAmountFocused}
            @blur=${this.customAmountBlurred}
          />
        </label>
      </div>
    `}customRadioSelected(){this.customAmountInput.focus()}customAmountFocused(t){let o=t.target;this.customAmountSelected=!0,this.handleCustomAmountInput(o.value)}customAmountBlurred(){this.updateSelectedDonationInfo()}coverFeesChecked(t){let e=t.target.checked;this.updateDonationInfo({coverFees:e})}customAmountChanged(t){let e=t.target.value;this.customAmountSelected=!0,this.handleCustomAmountInput(e)}handleCustomAmountInput(t){let o=parseFloat(t);isNaN(o)?this.dispatchEditDonationError(c.InvalidDonationAmount):this.amountChanged(o)}handleDonationInfoStatus(t){switch(t){case c.ValidDonationAmount:this.error=void 0;break;case c.DonationTooHigh:this.error=a`
          To make a donation of $10,000 or more, please contact our philanthropy
          department at
          <a href="mailto:donations@archive.org">donations@archive.org</a>
        `,this.dispatchEditDonationError(t);break;case c.DonationTooLow:this.customAmountInput.value.length>0&&(this.error=a` Please select an amount (minimum $1) `),this.dispatchEditDonationError(t);break;case c.InvalidDonationAmount:this.error=a` Please enter a valid donation amount `,this.dispatchEditDonationError(t);break}}amountChanged(t){let o=this.getDonationInfoStatus(t);this.handleDonationInfoStatus(o),o===c.ValidDonationAmount&&this.updateDonationInfo({amount:t})}getDonationInfoStatus(t){return isNaN(t)?c.InvalidDonationAmount:t>=1e4?c.DonationTooHigh:t<1?c.DonationTooLow:c.ValidDonationAmount}radioSelected(t){let o=t.target,e=o.name,{value:n}=o;switch(e){case d.Amount:this.presetAmountChanged(parseFloat(n));break;case d.DonationType:this.updateDonationInfo({donationType:n});break;default:break}}monthlyCheckboxChecked(t){let e=t.target.checked?h.Monthly:h.OneTime;this.updateDonationInfo({donationType:e})}dispatchEditDonationError(t){let o=new CustomEvent("editDonationError",{detail:{error:t}});this.dispatchEvent(o)}presetAmountChanged(t){this.error=void 0,this.customAmountSelected=!1,this.customAmountInput&&(this.customAmountInput.value=""),this.updateDonationInfo({amount:t})}updateDonationInfo(t){var o,e,n;let f=new S({donationType:(o=t.donationType)!==null&&o!==void 0?o:this.donationInfo.donationType,amount:(e=t.amount)!==null&&e!==void 0?e:this.donationInfo.amount,coverFees:(n=t.coverFees)!==null&&n!==void 0?n:this.donationInfo.coverFees});this.donationInfo=f;let g=new CustomEvent("donationInfoChanged",{detail:{donationInfo:f}});this.dispatchEvent(g)}static get styles(){let t=s`var(--paymentButtonBorderColor, #333)`,o=s`var(--paymentButtonGridGap, 1rem)`,e=s`var(--paymentButtonFontSize, 1.6rem)`,n=s`var(--paymentButtonFontColor, #000)`,f=s`var(--paymentButtonSelectedFontColor, #000)`,g=s`var(--paymentButtonSelectedColor, #f9bf3b)`,$=s`var(--paymentButtonFocusedOutlineColor, #7fb3f9)`,D=s`var(--paymentButtonColor, #fff)`,I=s`var(--coverFeesFontSize, 1.2rem)`,x=s`var(--coverFeesFontWeight, bold)`,T=s`var(--customAmountWidth, 4rem)`,F=s`var(--inputFieldFontColor, #333)`,B=s`var(--inputBorder, 1px solid #d9d9d9)`,M=s`var(--paymentSelectorAmountColumnCount, 5)`,w=s`var(--paymentSelectorCustomAmountColSpan, 3)`;return s`
      :host {
        --formSectionContentBackgroundColor: var(
          --editFormBgColor,
          transparent
        );
        --formSectionBadgeBackgroundColor: var(--editFormBadgeBgColor, #333);
        --formSectionBadgeFontColor: var(--editFormBadgeFontColor, #fff);
        --formSectionTextColor: var(--editFormTextColor, #333);
      }
      .errors {
        color: red;
        font-size: 1.4rem;
        margin-top: 0.5rem;
      }

      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: grid;
        grid-gap: ${o};
      }

      li {
        margin: 0;
        padding: 0;
        display: inline-block;
      }

      .frequency-selector {
        grid-template-columns: repeat(2, 1fr);
      }

      .amount-selector {
        grid-template-columns: repeat(${M}, 1fr);
      }

      .custom-amount {
        grid-column: span ${w};
      }

      .selection-button {
        height: 3rem;
      }

      .selection-button label {
        padding: 0 0.3rem;
        display: flex;
        cursor: pointer;
        text-align: center;
        font-size: ${e};
        font-weight: bold;
        border: 1px solid ${t};
        border-radius: 5px;
        background-color: #ccc;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      label[for='custom-amount-button'] {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .custom-amount-text {
        white-space: nowrap;
        margin-right: 0.5rem;
      }

      input[type='radio'] {
        opacity: 0;
        width: 0;
        height: 0;
        position: absolute;
      }

      input[type='radio'] + label {
        color: ${n};
        background-color: ${D};
      }

      input[type='radio']:checked + label {
        color: ${f};
        background-color: ${g};
      }

      input[type='radio']:focus + label {
        outline: 2px solid ${$};
      }

      .checkbox-options {
        margin-top: 1rem;
      }

      .checkbox-option-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .checkbox-option-container input {
        width: 2rem;
      }

      .checkbox-option-container label {
        font-size: ${I};
        font-weight: ${x};
        flex: 1;
      }

      #custom-amount-input {
        width: ${T};
        font-size: 1.6rem;
        font-weight: bold;
        color: ${F};
        padding: 0.1rem;
        border: ${B};
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
      }
    `}};r([m({type:Object})],u.prototype,"donationInfo",void 0);r([m({type:String})],u.prototype,"stepNumberMode",void 0);r([m({type:Number})],u.prototype,"defaultSelectedAmount",void 0);r([m({type:Array})],u.prototype,"amountOptions",void 0);r([m({type:String})],u.prototype,"amountSelectionLayout",void 0);r([m({type:String,reflect:!0})],u.prototype,"frequencySelectionMode",void 0);r([m({type:String,reflect:!0})],u.prototype,"customAmountMode",void 0);r([m({type:String,reflect:!0})],u.prototype,"coverFeesCheckboxMode",void 0);r([m({type:String,reflect:!0})],u.prototype,"amountTitleDisplayMode",void 0);r([k()],u.prototype,"error",void 0);r([k()],u.prototype,"customAmountSelected",void 0);r([C("#custom-amount-button")],u.prototype,"customAmountButton",void 0);r([C("#custom-amount-input")],u.prototype,"customAmountInput",void 0);u=r([N("donation-form-edit-donation")],u);export{u as DonationFormEditDonation,p as DonationFormEditDonationStepNumberMode,v as EditDonationAmountSelectionLayout,l as EditDonationFrequencySelectionMode,c as EditDonationInfoStatus,d as EditDonationSelectionGroup};
//# sourceMappingURL=donation-form-edit-donation.mjs.map